import { defineMessages } from 'react-intl';

export const i18n: {
	jiraFilterProjectLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterProjectLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterProjectPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	project: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	project: {
		id: 'dynamic-cards-search-page.filters.names.project',
		defaultMessage: 'Project',
		description:
			'Label for the project filter dropdown shown in the search page filter bar, allowing users to narrow search results by a specific Jira project.',
	},
	jiraFilterProjectPlaceholder: {
		id: 'dynamic-cards-search-page.jira.filter.project.placeholder',
		defaultMessage: 'Find projects',
		description: 'Placeholder for project filter search input',
	},
	jiraFilterProjectLabelSelected: {
		id: 'dynamic-cards-search-page.jira.filter.project.selected',
		defaultMessage: 'Selected',
		description:
			'Section heading label shown in the Jira project filter dropdown to group projects that the user has already selected.',
	},
	jiraFilterProjectLabelUnselected: {
		id: 'dynamic-cards-search-page.jira.filter.project.unselected',
		defaultMessage: 'Suggested',
		description:
			'Section heading label shown in the Jira project filter dropdown to group projects that the system suggests but the user has not yet selected.',
	},
});
